// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__39P81","name":"ConsentHeader_name__ogF7l","birthday":"ConsentHeader_birthday__OVU2S","skeleton":"ConsentHeader_skeleton__aRfHK"};